import axios from "axios";
import SnackbarService from "../../../app/components/theme/Snackbar/service";
import BlockUIService from "../../../app/components/theme/BlockUI/service";

const URL = `${process.env.REACT_APP_API_LOCATION}/Admin/AccountCancellations`;

const api = {
  load: async (period: string) => {
    BlockUIService.show();
    try {
      const response = await axios.get(URL, { params: { period } });
      return response.data || [];
    } catch (e: any) {
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || "Ha ocurrido un problema", "error");
      return [];
    } finally {
      BlockUIService.hide();
    }
  },
  statistics: async (period: string) => {
    BlockUIService.show();
    try {
      const response = await axios.get(`${URL}/Statistics`, { params: { period } });
      return response.data || { monthly: [], byReason: [] };
    } catch (e: any) {
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || "Ha ocurrido un problema", "error");
      return { monthly: [], byReason: [] };
    } finally {
      BlockUIService.hide();
    }
  },
};

export default api;
